import React, {useState, useRef} from 'react';
import {Overlay} from 'react-bootstrap';
import '../../assests/css/managemenu.scss';

export type categoryMenuItemIdType = 'Edit' | 'Delete' | 'None';

interface categoryManageMenuProps {
    targetElement: React.ReactElement,
    targetId: string,
    onClick?: (showMenu: boolean, id: string) => void,
    onClickMenuItem: (menuId: categoryMenuItemIdType) => void,
}

function CategoryManageMenu(props: categoryManageMenuProps) {
    const {targetElement, targetId, onClickMenuItem, onClick} = props;
    const [
        showMenu,
        setShowMenu,
    ] = useState<boolean>(false);
    const targetRef = useRef(null);

    const handleShowMenu = (value: boolean) => {
        setShowMenu(value);
        if (onClick && value) {
            onClick(value, targetId)
        }
    };

    const renderContent = () => {
        return (
            <div className='manage-user-menu'>
                <div className='manage-user-menu-item' onClick={() => onClickMenuItem('Edit')}>Edit</div>
                <div className='manage-user-menu-item' onClick={() => onClickMenuItem('Delete')}>Delete</div>
            </div>
        );
    }
    return (
        <>
            <div ref={targetRef} onClick={() => handleShowMenu(!showMenu)} className='manage-user-menu-trigger'>{targetElement}</div>
            <Overlay target={targetRef.current} show={showMenu} rootClose={true} placement='left' rootCloseEvent='click' onHide={() => handleShowMenu(false)}>
                {({
                    placement: _placement,
                    arrowProps: _arrowProps,
                    show: _show,
                    popper: _popper,
                    hasDoneInitialMeasure: _hasDoneInitialMeasure,
                    ...props
                }) => (
                    <div {...props}>
                        {renderContent()}
                    </div>
                )}
            </Overlay>
        </>
    );
}

export default CategoryManageMenu;
